import { Block, Prize } from '@contest-web/components/src/components/EntryCard';
import shuffle from 'lodash/shuffle';

export class EntriesRepository {

  static async getEvent(id: number | string) {
    const data: any = await import('../../public/json/mysta.json');
    return data[`${id}`];
  }

  static async getProfile(id: number | string) {
    const { data } = await import('../../public/json/profile.json');
    return data.filter((profile: any) => profile.id == id)[0];
  }

  static async getEntry(id: number | string, target?: { block?: Block; prize: Prize }) {
    const { list, block, prize } = await import('../../public/json/entry.json');
    let result = list.filter((entry: any) => entry.id == id);
    if (!target) {
      return result[0];
    }

    if (target.block) {
      const targetBlock = block[target.block] || [];
      result = result.filter((entry: any) => targetBlock.includes(entry.id));
    }
    const targetPrize = prize[target.prize] || [];
    result = result.filter((entry: any) => targetPrize.includes(entry.id));
    return result[0];
  }

  static async getEntries(target?: { block?: Block; prize: Prize }) {
    const { list, block, prize } = await import('../../public/json/entry.json');
    let result = shuffle(list);
    if (!target) {
      return result;
    }
    if (target.block) {
      const targetBlock = block[target.block] || [];
      result = result.filter((entry: any) => targetBlock.includes(entry.id));
    }
    const targetPrize = prize[target.prize] || [];
    result = result.filter((entry: any) => targetPrize.includes(entry.id));
    return result;
  }

  static async getMaxPrize(id: number | string) {
    const { prize } = await import('../../public/json/entry.json');
    if (prize.final.includes(+id)) {
      return Prize.final;
    }
    if (prize.semifinal.includes(+id)) {
      return Prize.semifinal;
    }
    if (prize.third.includes(+id)) {
      return Prize.third;
    }
    if (prize.second.includes(+id)) {
      return Prize.second;
    }
    if (prize.first.includes(+id)) {
      return Prize.first;
    }
    return undefined;
  }
}
